import Vue from 'vue';
import Vuex from 'vuex';
import db from '@/db';
import { auth } from 'firebase';
import state from './_state';
import getters from './_getters';
import actions from './_actions';
import mutations from './_mutations';
import { version } from '../../package.json';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: Object.assign(state, { version }),
  getters,
  mutations,
  actions,
});

store.subscribeAction({
  before: (action, state) => {
    const actions = [
      'addTag',
      'removeTag',
      'searchSnippet',
      'selectLanguage',
      'selectSnippet',
      'selectTag',
      'undo',
      'undoIncrement',
    ];
    if (actions.includes(action.type)) return;
    localStorage.setItem('store-snapshot-' + state.undocounter, JSON.stringify(state));
  },
});

store.subscribe((mutation, state) => {
  const mutationTypes = [
    'UNDO',
    'DELETE_HISTORY',
    'SELECT_SNIPPET',
    'UNDO_INCREMENT',
    'UPDATE_USER_PREFERENCES',
    'INITIALISE_STORE',
  ];
  if (mutationTypes.includes(mutation.type)) return;
  let currentUser = auth().currentUser;

  if (currentUser) {
    db.collection('users')
      .doc(currentUser.uid)
      .update({ ...state });
  }
  store.dispatch('undoIncrement');
  localStorage.setItem('store', JSON.stringify(state));
});

export default store;
